import React from "react"
import { Switch, Route } from "react-router"
import ReactTooltip from "react-tooltip"

import "shared/styles/app.css"

import ScrollRestoration from "shared/components/ScrollRestoration"
import ChristmasBanner from "shared/components/ChristmasBanner/ChristmasBanner"
import Search from "shared/components/Search"
import Footer from "shared/components/Footer"

import Meta from "./Meta"
import Parcels from "./Parcels"
import Parcel from "./Parcel"
import Faq from "./Faq"

import NotFound from "./NotFound"

const scrollTop = () => {
  window.scrollTo(0, 0)
}

const App = () => (
  <ScrollRestoration>
    <Meta />
    <ChristmasBanner />
    <Search />
    <div className="container">
      <Switch>
        <Route exact path="/" render={() => null} />
        <Route path="/parcel/:id" component={Parcel} onEnter={scrollTop} />
        <Route path="/parcels" component={Parcels} onEnter={scrollTop} />
        <Route path="/faq" component={Faq} onEnter={scrollTop} />
        <Route path="*" component={NotFound} onEnter={scrollTop} />
      </Switch>
      <ReactTooltip effect="solid" />
    </div>
    <Footer />
    <ReactTooltip effect="solid" />
  </ScrollRestoration>
)

export default App



// WEBPACK FOOTER //
// ./src/views/App.js